import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	TextInput
} from 'react-admin';

import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { LiveTraining } from "./LiveTraining";
import { LiveTrainingList } from "./LiveTrainingList";
import { LiveTrainingDatagrid } from "./LiveTrainingDatagrid";


const TrainingsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'title', header: 'Title' },
	{ key: 'link', header: 'Link' },
	{ key: 'organization.name', header: 'Organization' }
];

export const LiveTrainingsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: LiveTraining) => entity;

	const trainingsFilter = [
		<TextInput source="title" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('אימוני לייב', exportFields, exportDataMapper)}
				{...props}
				filters={trainingsFilter}
				bulkActionButtons={<TrainingsBulkActionButtons/>}
				title="LIVE_TRAININGS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <LiveTrainingList/> : <LiveTrainingDatagrid/>}
			</List>
		</Fragment>
	);
};
